export default "__VITE_ASSET__fyaT8n7___"